export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'USER-MANAGEMENT': {
    ADD_USER_TITLE: 'Add new user',
    EDIT_USER_TITLE: 'Edit user',
    TITLE: 'User Management',
    TABLE: {
      TITLE: 'Users',
      FILTERS: {
        SEARCH: 'Search',
        SEARCH_PLACEHOLDER: 'Search by name or email',
      },
      HEADER: {
        FULL_NAME: 'Full name',
        EMAIL: 'Email address',
        LOCALE: 'Language',
        ROLES: 'Role',
        SCOPED_LOCATIONS: 'Locations',
        SCOPED_OFFERS: 'Jobs',
        ENABLED: 'Status',
        ADDED_BY: 'Added by',
        CREATED_AT: 'Joined',
        CREATED_AT_TOOLTIP: 'Date the user was added',
        ACTIONS: 'Actions',
      },
      BODY: {
        GROUP_USER_PERMISSIONS: {
          OWNER: 'Owner',
          ADMIN: 'Admin',
          PUBLISHER: 'Job Manager',
          CANDIDATE_MANAGER: 'Candidate Manager',
          PUBLISHER_CANDIDATE_MANAGER: 'Job and Candidate Manager',
          GUEST: 'Guest',
          PLATFORM_ADMIN: 'Platform Admin',
          PLATFORM: 'Platform',
          UNDEFINED: 'Undefined',
        },
        SCOPED_ALL: 'All',
        SCOPED_TOOLTIP: 'User access scope',
      },
      ACTIONS: {
        DELETE: 'Delete user',
        MANAGE_PERMISSIONS: 'Manage permissions',
      },
      NO_DATA: 'No users found.',
    },
    DELETE_USER: {
      CONFIRM_DELETE: {
        HEADER: 'Delete user',
        MESSAGE: 'This person will lose access to the entire platform.<br>Do you wish to continue?',
        ACCEPT: 'Delete',
        REJECT: 'Cancel',
      },
      SUCCESS_DELETE: {
        HEADER: 'User deleted',
        MESSAGE: 'User deleted successfully.',
      },
    },
    PERMISSIONS_MODAL: {
      TITLE: 'Manage Permissions',
      DESCRIPTION: 'Configure access permissions for this user. You can grant workspace-wide access, or restrict it to specific locations or jobs.',
      CURRENT_PERMISSIONS: 'Current Permissions',
      NO_PERMISSIONS: 'This user doesn\'t have any permissions yet.',
      NO_PERMISSIONS_REQUIRED: 'Please add at least one permission before saving.',
      ADD_PERMISSION: 'Add New Permission',
      SCOPE_TYPE: {
        ENTITY: 'Entire Workspace',
        LOCATION: 'Specific Location',
        ENTITY_LOCATION: 'Specific Location', // Fallback for backend variant
        OFFER: 'Specific Job',
      },
      TABLE: {
        SCOPE_TYPE: 'Scope Type',
        ENTITY_NAME: 'Name',
        STATUS: 'Status',
        ACTIONS: 'Actions',
        REMOVE: 'Remove permission',
      },
      VALIDATION: {
        VALID: 'Valid',
        REDUNDANT: 'Overlapping',
        REASON: 'Reason',
        SUMMARY_WARNING: '⚠️ {{redundant}} out of {{total}} roles won\'t be saved because they overlap with broader permissions (Workspace > Location > Job).',
        VALIDATING: 'Validating permissions...',
        ERROR: 'Failed to validate permissions. You can save at your own risk.',
        REDUNDANT_BY_ENTITY: 'Covered by workspace-wide access: {{entity_name}}',
        REDUNDANT_BY_LOCATION: 'Covered by location access: {{location_name}}',
        ERROR_MISSING_GROUP: 'Error: Missing role identifier',
        ERROR_INVALID_SCOPE: 'Error: Invalid scope definition',
        REDUNDANT_GENERIC: 'Covered by a broader permission',
      },
      ENTITY_LEVEL_ALL: 'Entire workspace',
      FORM: {
        SCOPE_TYPE: 'Scope Type',
        SELECT_SCOPE_TYPE: 'Select access scope',
        LOCATION: 'Location',
        SELECT_LOCATION: 'Select a location',
        OFFER: 'Job',
        SEARCH_OFFER: 'Select a job',
        NO_OFFER_RESULTS: 'No jobs found',
        OFFER_HINT: 'Type at least 3 characters to search',
        ADD_BUTTON: 'Add permission',
      },
      DUPLICATE_WARNING: {
        HEADER: 'Duplicate Permission',
        MESSAGE: 'This permission is already assigned.',
      },
      SUCCESS: {
        HEADER: 'Permissions Updated',
        MESSAGE: 'Permissions have been updated successfully.',
      },
      ERROR: {
        HEADER: 'Error Saving',
        MESSAGE: 'Something went wrong while saving permissions. Please try again.',
      },
    },
    CONFIRM_MODAL: {
      TITLE: '⚠️ Overlapping roles detected — action required',
      DESCRIPTION: 'Permissions follow a hierarchy: Workspace > Location > Job. If you grant access to the entire Workspace, any Location or Job permissions you added are already covered and become redundant. Similarly, if you grant access to a Location, any Job permissions within that location are redundant. You must remove the roles listed below before you can save.',
      WARNING: 'You have {{redundant}} redundant role(s) out of {{total}} total. Please remove them to continue.',
      VALID_ROLES_TITLE: 'Valid roles (will be saved)',
      REDUNDANT_ROLES_TITLE: 'Redundant roles (must be removed)',
      REASON: 'Why it\'s redundant',
      SAVE_ANYWAY: 'Save anyway',
      GO_BACK: 'Go back and fix',
    },
    ASSIGN_PERMISSIONS: {
      PAGE_TITLE: 'User Management',
      STEP_LABEL: 'Step 2 · Role & Permissions',
      ENTITY_SCOPE_LABEL: 'Full access',
      ENTITY_SCOPE_DESCRIPTION: 'When enabled, this user will have access to all locations and jobs based on their role.',
      ENTITY_SCOPE_DESCRIPTION_ITALIC: 'Disable this to configure specific permissions below.',
      ENTITY_SCOPE_CONFIRM: {
        HEADER: 'Enable full access',
        MESSAGE: 'Enabling this will remove any previously configured permissions. The user will now have access to all available locations and jobs, according to their assigned role.',
        ACCEPT: 'Continue',
        REJECT: 'Cancel',
      },
      SPECIFIC_PERMISSIONS_TITLE: 'Specific permissions',
      SPECIFIC_PERMISSIONS_DESCRIPTION: 'This user will only have access to the locations and jobs you select below.',
      ADD_PERMISSION_SECTION: 'Add permission',
      CONFIGURED_PERMISSIONS: 'Configured permissions',
      // Wizard: city step
      SELECT_CITY: 'Select a city',
      CITY_LABEL: 'City',
      // Wizard: location step
      SELECT_LOCATION: 'Select a location',
      LOCATION_LABEL: 'Location',
      SELECT_ALL: 'All',
      ALL_LOCATIONS_IN_CITY: 'All locations in {{city}}',
      // Wizard: offers step
      SELECT_OFFERS_FOR_LOCATION: 'Select jobs',
      ALL_OFFERS_IN_LOCATION: 'All jobs at this location',
      ALL_LOCATIONS: 'All branches',
      ALL_OFFERS: 'All jobs',
      OFFER_LABEL: 'Job',
      CONFIRM_OFFERS: 'Confirm selection',
      // Wizard: controls
      WIZARD_CANCEL: 'Cancel',
      WIZARD_IN_PROGRESS: 'Complete or cancel the current selection before saving',
      // Remove card
      REMOVE_PERMISSION: 'Remove permission',
      REMOVE_PERMISSION_CONFIRM: {
        HEADER: 'Remove permission',
        MESSAGE: 'Are you sure you want to remove <strong>{{name}}</strong>?',
        ACCEPT: 'Yes, remove',
        REJECT: 'Cancel',
      },
      GLOBAL_ACCESS_BLOCKED_TOOLTIP: 'This role already has full access. You cannot disable this option.',
      // Permission card labels
      CARD_OFFER: 'Offer',
      CARD_DATA: 'Details',
      CARD_LOCATION: 'Branch',
      CARD_CITY: 'City',
      CARD_PUBLISHED: 'Published',
      LEAVE_CONFIRM: {
        HEADER: 'User needs permissions',
        MESSAGE: 'If you leave now, the user will be created but won\'t have any permissions assigned. Do you want to leave anyway?',
        ACCEPT: 'Yes, leave',
        REJECT: 'Keep editing',
      },
    },
    FORM_USER: {
      FOOTER: 'Once invited, this user will receive an email with their login credentials.',
      FOOTER_EDIT: 'Once saved, this user will receive an email with their login credentials.',
      FOOTER2: 'If they don\'t see it in their main inbox, ask them to check their spam folder.',
      BUTTONS: {
        SAVE: 'Save',
        INVITE: 'Invite',
        CONTINUE: 'Continue',
        CANCEL: 'Cancel',
        DELETE: 'Delete',
        BACK: 'Go back',
        GO_TO_GENERAL_DATA: 'General info',
      },
      SCOPE_INFO: {
        DESCRIPTION: 'By default, the user will have workspace-wide access. Check the box if you want to restrict their access to specific locations or jobs.',
        RESTRICT_CHECKBOX: 'Restrict access to specific locations or jobs',
      },
      PERMISSION_DEFAULT_CONFIRM: {
        HEADER: 'No permissions set',
        MESSAGE: 'You closed without saving any permissions. If you continue, workspace-wide access will be assigned by default. Do you want to continue or go back to permissions?',
        ACCEPT: 'Assign full access',
        REJECT: 'Go back',
        SUCCESS: 'Workspace-wide access has been assigned by default.',
      },
      FIELDS: {
        FIRSTNAME: {
          LABEL: 'First name',
          PLACEHOLDER: 'Enter first name',
        },
        LASTNAME: {
          LABEL: 'Last name',
          PLACEHOLDER: 'Enter last name',
        },
        EMAIL: {
          LABEL: 'Email address',
          PLACEHOLDER: 'Enter email address',
        },
        LOCALE: {
          LABEL: 'Language',
          PLACEHOLDER: 'Select language',
          OPTIONS: {
            EN: 'English',
            ES: 'Spanish',
          },
        },
        GROUP: { LABEL: 'Role', PLACEHOLDER: 'Select a role', ROLE_READONLY_TOOLTIP: 'To modify the role, go to the next screen pressing Continue button' },
        ENABLED: { LABEL: 'Active' },
      },
      SUCCESS_EDIT: {
        HEADER: 'User updated',
        MESSAGE: 'User updated successfully.',
      },
      MESSAGES: {
        USER_CREATED: 'User created successfully. An invitation email has been sent.',
        USER_UPDATED: 'User updated successfully.',
      },
      CROP_IMAGE: {
        TITLE: 'Crop image',
        CONFIRM: 'Apply',
      },
      ERRORS: {
        USER_NOT_FOUND: 'User not found.',
        NOT_AUTHORIZED: 'You don\'t have permission to delete users.',
        EMAIL_NOT_BLANK: 'Email is required.',
        EMAIL_NOT_VALID: 'Invalid email address.',
        EMAIL_ALREADY_EXISTS: 'This email is already registered.',
        FIRSTNAME_NOT_BLANK: 'First name is required.',
        LASTNAME_NOT_BLANK: 'Last name is required.',
        ENABLED_NOT_BLANK: 'Status is required.',
        ENABLED_NOT_BOOL: 'Status must be true or false.',
        LOCALE_NOT_VALID: 'Invalid language.',
        UNKNOWN_ERROR: 'Something went wrong. Please try again.',
      },
    },
  },
} as const;
